export const GET_GIFT_DETAILS = 'app/Print/GET_GIFT_DETAILS';
export const GET_GIFT_DETAILS_SUCCESS = 'app/Print/GET_GIFT_DETAILS_SUCCESS';
export const GET_GIFT_DETAILS_FAILURE = 'app/Print/GET_GIFT_DETAILS_FAILURE';
